<template>
  <Loading :forceLightMode="true" />
</template>

<script>
import Util from '@/util'
import Auth from '@/api/auth'
import { mapActions } from 'vuex'
import Loading from '@/components/Loading'

export default {
  components: {
    Loading,
  },
  async mounted() {
    const {
      token,
      from,
    } = this.$route.query

    if (token && from == 'presenter') {
      await this.crossAppLogin(token)
    } else {
      this.$router.push({
        name: 'home',
      })
    }
  },
  methods: {
    ...mapActions(['setCurrentUserAction']),
    async crossAppLogin(presenterToken) {
      let token
      let user

      try {
        const res = await Auth.crossAppLogin({
          token: presenterToken,
        })
        token = res.token
        user = res.user
        Util.setCookieToken(token)

        if (user && user.id) {
          await this.setCurrentUserAction(user)
          window.localStorage.setItem('show-toasted-login', true)
        }
        const redirect = Util.getParamValue('redirect', window.location.href)

        if (redirect) {
          window.location.href = redirect
        } else {
          this.$router.push({
            name: 'Profile',
          })
        }
      } catch (err) {
        // console.error(err)
      }
    },
  },
}
</script>
